import AbstractScene from './AbstractScene.js';
import { B2Data } from '../consts/Data.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import Btn from '../prefabs/Btn.js';
import TxtBtn from '../prefabs/TxtBtn.js';
import ScreenMaker from '../prefabs/ScreenMaker.js';


export default class ActiviteB2 extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteB2"
        })
    }
    init(data) {
        this._init(data);
        this.step = 0
        this.mainContainer = undefined
        this.allTxtBtns = [];
        this.allBtnsData = B2Data.btns;
        this.allBtns = [];
    }

    preload() {
        this._preload();
    }

    create() {
        // this.addSounds();
           this.sounds = {
            pop: this.sound.add('pop', { volume: 0.1 }),
            whoosh: this.sound.add('whoosh', { volume: 0.3 }),
            win: this.sound.add('win', { volume: 0.3 }),
            lose: this.sound.add('lose', { volume: 0.1 }),
        };
        this.addBackgroundMusique('minimal')
        this.addHeader("LES TRAITEMENTS MÉDICAMENTEUX");
    }

    launchScene() {
        for (let i = 0; i < this.allBtnsData.length; i++) {
            const element = this.allBtnsData[i];
            let btnName = 'btn' + (i + 1)
            this[btnName] = new Btn(this, 121, 515, 140, element);
            this.allBtns.push(this[btnName]);
            this[btnName].setAlpha(0);
            this[btnName].setClickFunction(() => {
                this.screenMaker[element.funct]()
            })
        }

        this.allBtns.forEach((element, i) => {
            this.tweens.add({
                targets: element,
                alpha: 1,
                delay: i * 100,
                duration: 500,
                ease: 'Power2',
                onComplete: () => {
                    if (i === this.allBtns.length - 1) {
                        this.screenMaker = new ScreenMaker(this, B2Data.screens);
                        this.screenMaker.firstScreen()
                    }
                }
            })
        })
    }
    addNavigationBtns() {
        this.nextBtn = new ButtonImageSliced(this, 1580, 992, 320, 80, "bouton", "Suivant")
        this.nextBtn.setUnlocked()
        this.nextBtn.setAlpha(0);
        this.nextBtn.setClickFunction(() => {
            this.tweens.add({
                targets: [this.mainContainer, this.btn3, this.btn4],
                alpha: 0,
                duration: 500,
                ease: 'Power2',
                onComplete: () => {
                    this.screenMaker.eleventhScreen()
                }
            })

        })
    }
}